import React, { useState } from "react";
import { useDispatch } from "react-redux";
import UsersRequests from "services/users";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  IconButton,
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import CloseIcon from "@material-ui/icons/Close";
import GridContainer from "@jumbo/components/GridContainer";

const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
    marginBlock: "16px",
    color: theme.palette.grey[500],
  },
  input: {
    display: "none",
  },
  uploaderContainer: {
    width: "60%",
    minWidth: "200px",
    marginInline: "auto",
    marginBlock: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderColor: theme.palette.grey[500],
    borderWidth: "2px",
    borderStyle: "dashed",
    borderRadius: "10px",
  },
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "80%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  inputContainer: {
    "& p": {
      fontSize: "14px",
      marginBottom: "10px",
    },
  },
  formControl: {
    width: "100%",
  },
}));

export default function AddBatchAccessDialog({
  open,
  handleClose,
  isALManamger,
}) {
  const [currentFile, setCurrentFile] = useState(null);
  const [currentFileName, setCurrentFileName] = useState("");

  const [type, setType] = useState();
  const [topic, setTopic] = useState("");
  const [topicString, setTopicString] = useState("");

  const dispatch = useDispatch();
  const classes = useStyles();

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setCurrentFile(file);
      setCurrentFileName(file.name);
    }
  };
  const handleUploadAndClose = () => {
    if (currentFile) {
      if (isALManamger) {
        const data = {
          topic: topic,
          type: type,
        };
        if (topicString) {
          data["topicString"] = topicString;
        }
        dispatch(UsersRequests.addBatchUserAccessManagement(currentFile, data));
      } else {
        dispatch(UsersRequests.addBatchUserAccess(currentFile));
      }
      handleClose();
      setCurrentFile();
      setCurrentFileName("");
    }
  };

  const handleRemove = () => {
    setCurrentFile();
    setCurrentFileName("");
  };

  const addAccessContent = (
    <GridContainer className={classes.girdContainer}>
      <Grid item xs={12} md={6} className={classes.inputContainer}>
        <Typography>نوع</Typography>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="type-select-outlined-label">نوع</InputLabel>
          <Select
            labelId="type-select-outlined-label"
            id="type-select-outlined"
            value={type}
            onChange={(e) => setType(e.target.value)}
            label="نوع"
          >
            <MenuItem value={"CodeMeli"}>کد ملی</MenuItem>
            <MenuItem value={"CodePersoneli"}>کد پرسنلی</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6} className={classes.inputContainer}>
        <Typography>موضوع</Typography>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="topic-select-outlined-label">موضوع</InputLabel>
          <Select
            labelId="topic-select-outlined-label"
            id="topic-select-outlined"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            label="موضوع"
          >
            <MenuItem value={"General"}>عمومی</MenuItem>
            <MenuItem value={"JoftPooch"}>جفت پوچ</MenuItem>
            <MenuItem value={"Other"}>دیگر</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      {topic === "Other" && (
        <Grid item xs={12} md={6} className={classes.inputContainer}>
          <Typography>نام موضوع</Typography>
          <TextField
            id="otherStringInput"
            label="نام موضوع"
            variant="outlined"
            className={classes.customInput}
            value={topicString}
            onChange={(e) => setTopicString(e.target.value)}
          />
        </Grid>
      )}
    </GridContainer>
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth={"sm"}
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          وارد کردن گروهی کاربران
        </DialogContentText>
        {isALManamger && addAccessContent}
        <Typography className={classes.title}>
          برای آپلود فایل بر روی آیکون فایل کلیک کنید!
        </Typography>
        <Box className={classes.uploaderContainer}>
          <input
            accept=".csv"
            className={classes.input}
            onChange={handleFileChange}
            id="icon-button-file"
            type="file"
          />
          <label htmlFor="icon-button-file">
            {!currentFile && (
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="span"
              >
                <NoteAddIcon fontSize="large" />
              </IconButton>
            )}
          </label>
          {currentFile && (
            <>
              <IconButton
                color="secondary"
                aria-label="delete picture"
                component="span"
                onClick={handleRemove}
              >
                <CloseIcon />
              </IconButton>
              <Typography>{currentFileName}</Typography>
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleUploadAndClose} color="primary">
          تایید و آپلود
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
